export default "__VITE_ASSET__49dbd36e__"